import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// material
import { styled } from "@mui/material/styles";

// ----------------------------------------------------------------------
const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const RootStyle = styled("div")({
  display: "flex",
  minHeight: "100%",
  overflow: "hidden"
});

const MainStyle = styled("div")(({ theme }) => ({
  flexGrow: 1,
  overflow: "auto",
  minHeight: "100%",
  // paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up("lg")]: {
    // paddingTop: APP_BAR_DESKTOP + 24,
    // paddingLeft: theme.spacing(2),
    // paddingRight: theme.spacing(2)
  }
}));

// ----------------------------------------------------------------------

const ROLE_ADMIN = "admin";
const ROLE_MENTOR = "mentor";
const ROLE_PHD_3Y = "phd_3y";
const ROLE_PHD_5Y = "phd_5y";
const ROLE_POSTDOC = "post_doc";

export default function ProfileLayout() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { role, user: currentUser } = useSelector((state) => state.authReducer);

  useEffect(() => {
    if (role) {
      switch (role) {
        case ROLE_ADMIN:
          return navigate("/profile/admin", { replace: true });
        case ROLE_MENTOR:
          return navigate("/profile/mentor", { replace: true });
        case ROLE_POSTDOC:
          return navigate("/profile/post_doc", { replace: true });
        case ROLE_PHD_3Y:
          return navigate("/profile/phd_3y", { replace: true });
        case ROLE_PHD_5Y:
          return navigate("/profile/phd_5y", { replace: true });
        default:
          return;
      }
    }
  }, []);

  return (
    <RootStyle>
      <MainStyle>
        <Outlet />
      </MainStyle>
    </RootStyle>
  );
}
